<template>
  <div ref="mainPanel" class="nd-main-panel">
    <Breadcrumbs :items="breadcrumbs"/>
    <div class="nd-main-panel-content container-fluid">
      <div class="d-grid gap-2 d-md-flex justify-content-md-end" v-if="isInTrackerManagement || isInTemplateManagement">
        <PreviewButton v-if="isInTemplateManagement || isInTrackerManagement" />
        <GroupConfigurationPublisher v-if="isInTrackerManagement && isAutoSoftwareSelected"></GroupConfigurationPublisher>
        <SoftwareConfigurationPublisher v-if="isInTrackerManagement && !isAutoSoftwareSelected"></SoftwareConfigurationPublisher>
        <TemplateConfigurationPublisher v-if="isInTemplateManagement"></TemplateConfigurationPublisher>
      </div>
      <div class="row-fluid">
        <div class="span8">
          <h1>{{ pageTitle }}</h1>
        </div>
        <div class="span4">
        </div>
      </div>
      <div class="loading nd-loading" v-if="isLoadingContent || !breadCrumbsLoaded">
        <i class="icon-loading-large"></i>
      </div>
      <NuxtPage/>
    </div>
  </div>
</template>

<script lang="ts">
import SoftwareHelper from '~/helpers/SoftwareHelper';
import { defineComponent } from 'vue';
import Breadcrumbs from './Breadcrumbs.vue';
import BreadcrumbsDispatcher from '~/windowEvents/BreadcrumbsDispatcher';
import GroupConfigurationPublisher from '~/components/configurationPublisher/GroupConfigurationPublisher.vue';
import SoftwareConfigurationPublisher from '~/components/configurationPublisher/SoftwareConfigurationPublisher.vue';
import TemplateConfigurationPublisher from '~/components/configurationPublisher/TemplateConfigurationPublisher.vue';
import LoadingAnimation from '~/windowEvents/LoadingAnimation';
import PreviewButton from '~/components/preview/PreviewButton.vue';
import PublishConfigurationButton from '~/components/buttons/PublishConfigurationButton.vue';
import TitleDispatcher, { TitleEventDetail } from '~/windowEvents/TitleDispatcher';
import SelectedGroupHashChangeDispatcher from '~/windowEvents/SelectedGroupHashChangeDispatcher';
import { useRouter } from 'vue-router';

export default defineComponent({
  name: 'MainPanel',
  components: {
    Breadcrumbs,
    PreviewButton,
    PublishConfigurationButton,
    GroupConfigurationPublisher,
    SoftwareConfigurationPublisher,
    TemplateConfigurationPublisher,
  },
  props: {
    isUserAuthenticated: {
      type: Boolean,
      required: true,
    },
  },
  setup() {
    const router = useRouter();
    return {
      currentRouteName: () => String(router?.currentRoute?.value?.name)
    };
  },
  computed: {
    isInTemplateManagement() {
      return this.currentRouteName().startsWith('templates-');
    },
    isInTrackerManagement() {
      return this.currentRouteName().startsWith('trackers');
    },
  },
  methods: {
    setIsAutoSoftwareIsSelected() {
      const selectedSoftware = SoftwareHelper.getSelectedSoftwareObject();
      this.isAutoSoftwareSelected = SoftwareHelper.isAutoV10(selectedSoftware);
    },
    setPanelHeight(panel: HTMLElement) {
      panel.style.minHeight = (window.innerHeight - panel.offsetTop) + 'px';
    },
  },
  data() {
    return {
      panel: undefined as HTMLElement,
      breadcrumbs: [] as Array<BreadcrumbsItem>,
      breadCrumbsLoaded: false as boolean,
      isLoadingContent: false as boolean,
      pageTitle: '',
      isAutoSoftwareSelected: true,
    };
  },
  mounted() {
    this.setPanelHeight(this.$refs.mainPanel);
    window.addEventListener('resize', () => this.setPanelHeight(this.$refs.mainPanel));
  },
  beforeMount() {
    this.setIsAutoSoftwareIsSelected();

    window.addEventListener(TitleDispatcher.EVENT_TYPE, (event: Event) => {
      const titleEvent = event as CustomEvent<TitleEventDetail>;
      this.pageTitle = titleEvent.detail.title;
    });

    window.addEventListener(BreadcrumbsDispatcher.EVENT_TYPE, (event: Event) => {
      const breadcrumbEvent = event as CustomEvent<Array<BreadcrumbsItem>>;
      this.breadcrumbs = breadcrumbEvent.detail;
      this.breadCrumbsLoaded = true;
    });

    window.addEventListener(LoadingAnimation.EVENT_TYPE, (event: Event) => {
      const loadingEvent = event as CustomEvent<boolean>;
      this.isLoadingContent = loadingEvent.detail;
    });

    window.addEventListener(SelectedGroupHashChangeDispatcher.EVENT_TYPE, this.setIsAutoSoftwareIsSelected);
  },
});
</script>

